if (!customElements.get('product-variant-picker-bundle')) {
class ProductVariantPickerBundle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);
    this.currentVariant = this.getAttribute('data-selected-variant') || null;
    this.formLabelValue = this.querySelector('.form__label-value');
    this.productErrorMessage = document.querySelector('.product-form__error-message-wrapper');
  }

  connectedCallback() {
    this.getVariantData();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }

  onVariantChange(event) {
    this.updateOptions(); 
    this.updateMasterId();
    this.updateSelectedVariantHtml();
    this.updateVariantText();
    this.updateInventoryStatus();
    this.hideErrorMessage();
    this.updateGalleryItems();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedVariantHtml() {
    this.setAttribute('data-selected-variant', this.currentVariant.id);
  }

  updateVariantText() {
    // this.querySelectorAll('.product-form__input').forEach((item, i) => 
    //   item.querySelector('.form__label-value').innerHTML = this.options[i]
    // );
  }

  updateInventoryStatus() {
    const inventoryStatusElements = this.querySelectorAll('[data-inventory-variant-wrapper-id]');

    inventoryStatusElements.forEach((element) => {
      const variantId = parseInt(element.getAttribute('data-inventory-variant-wrapper-id'), 10);
      if (variantId === this.currentVariant.id) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  }

  hideErrorMessage() {
    if (!this.productErrorMessage) {
      return;
    }

    this.productErrorMessage.setAttribute('hidden', '');
  }

  updateGalleryItems() {
    const bundlePickers = document.querySelectorAll('product-variant-picker-bundle');
    const selectedVariantsIds = Array.from(bundlePickers).map((bundle) =>
      bundle.getAttribute('data-selected-variant')
    );

    const galleryElement = document.querySelector('gallery-carousel');
    if (!galleryElement) return;

    const isDesktopGrid = galleryElement.hasAttribute('desktop-grid') && window.innerWidth >= 768;

    // --- MAIN SLIDES (ONLY ADDITIONAL VARIANTS) ---
    const mainVariantSlides = galleryElement.querySelectorAll(
      '.splide__gallery [data-image-variant]'
    );

    // --- THUMBNAILS (ONLY ADDITIONAL VARIANTS) ---
    const thumbVariantSlides = galleryElement.querySelectorAll(
      '.thumbnail-carousel [data-image-variant]'
    );

    if (isDesktopGrid) {
      // DESKTOP GRID – only show/hide, without messing with Splide
      mainVariantSlides.forEach((item) => {
        const imageVariantId = item.getAttribute('data-image-variant');
        if (selectedVariantsIds.includes(imageVariantId)) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });

      thumbVariantSlides.forEach((item) => {
        const imageVariantId = item.getAttribute('data-image-variant');
        if (selectedVariantsIds.includes(imageVariantId)) {
          item.classList.remove('hidden');
        } else {
          item.classList.add('hidden');
        }
      });

      return;
    }

    // MOBILE / NORMAL CAROUSEL
    mainVariantSlides.forEach((item) => {
      const imageVariantId = item.getAttribute('data-image-variant');

      if (selectedVariantsIds.includes(imageVariantId)) {
        item.classList.remove('hidden', 'bundle-variant-slide');
        item.classList.add('splide__slide');
      } else {
        item.classList.add('hidden', 'bundle-variant-slide');
        item.classList.remove('splide__slide');
      }
    });

    thumbVariantSlides.forEach((item) => {
      const imageVariantId = item.getAttribute('data-image-variant');

      if (selectedVariantsIds.includes(imageVariantId)) {
        item.classList.remove('hidden', 'bundle-variant-thumb');
        item.classList.add('splide__slide', 'splide__thumbnail');
      } else {
        item.classList.add('hidden', 'bundle-variant-thumb');
        item.classList.remove('splide__slide', 'splide__thumbnail');
      }
    });

    if (galleryElement.main && galleryElement.thumbnails) {
      try {
        galleryElement.main.refresh();
        galleryElement.thumbnails.refresh();
      } catch (e) {
        console.warn('Error refreshing Splide after variant change', e);
      }
    }
  }
}

customElements.define('product-variant-picker-bundle', ProductVariantPickerBundle);
}